import React from 'react';
import { CalendarCheck, Lock, Sprout } from 'lucide-react';
import { dateLineText, taskDateValues } from '@/utils/planning';

// The two date lines of every task card (Dashboard / TaskList cards and the trial page's task rows): the
// customer's Time interval (locked) first, then Agrolab's Planned date - always both, "No date" when empty.
const SIZES = {
  // TaskCardSmall's task box
  card: { line: 'text-sm', icon: 'h-4 w-4', label: 'text-xs' },
  // A task row on the trial page
  row: { line: 'text-[11px]', icon: 'h-3 w-3', label: 'text-[10px] font-semibold uppercase tracking-wide' },
};

// With `bbch` (the trial page's rows), the task's BBCH follows on a line of its own when it has one, so it is never
// read as part of the Time interval's text.
export default function TaskDateLines({ task, size = 'card', bbch = false }) {
  const s = SIZES[size];
  const { timeInterval, planned } = taskDateValues(task);
  const iconClass = `${s.icon} text-gray-500 dark:text-gray-400`;
  const lines = [
    { testId: 'task-time-interval', icon: <Lock className={iconClass} aria-hidden="true" />, label: 'Time interval', value: dateLineText(timeInterval), title: "Set from the customer's agreement when the task was created" },
    { testId: 'task-planned-date', icon: <CalendarCheck className={iconClass} aria-hidden="true" />, label: 'Planned date', value: dateLineText(planned), title: "Agrolab's planned date" },
    ...(bbch && task?.bbch ? [{ testId: 'task-bbch', icon: <Sprout className={iconClass} aria-hidden="true" />, label: 'BBCH', value: String(task.bbch), title: 'The growth stage recorded on the task' }] : []),
  ];
  return (
    <div className="grid min-w-0 gap-y-1" data-testid="task-date-lines">
      {lines.map(({ testId, icon, label, value, title }) => (
        <div key={testId} data-testid={testId} className={`grid min-w-0 grid-cols-[auto_auto_minmax(0,1fr)] items-center gap-x-1.5 ${s.line}`} title={title}>
          {icon}
          <span className={`${s.label} text-gray-500 dark:text-gray-400`}>{label}</span>
          <span className="min-w-0 truncate" data-testid={`${testId}-value`} title={value}>{value}</span>
        </div>
      ))}
    </div>
  );
}
